// Constants and Labels used across the application

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Color palette
export const COLORS = {
  care: "#10b981",
  utility: "#3b82f6",
  creative: "#8b5cf6",
  extraction: "#ef4444",
  unknown: "#6b7280",
  female_only: "#ec4899",
  male_only: "#3b82f6",
  mixed: "#8b5cf6",
  system_aware: "#10b981",
  neutral: "#6b7280",
  market_first: "#f59e0b"
};

export const ORIENTATION_LABELS = {
  care: "Care-Centered",
  utility: "Utility-Centered",
  creative: "Creative",
  extraction: "Profit/Extraction",
  unknown: "Unknown"
};

export const ORIENTATION_DEFINITIONS = {
  care: "Human wellbeing focus: mental health, education, accessibility, community support, career guidance. Prioritizes user benefit over profit maximization.",
  utility: "Productivity & efficiency focus: automation, workflow optimization, time-saving tools. Neutral on ethics, focused on functional value.",
  creative: "Creative expression: art, music, video, design, content creation tools. Enables human creativity through AI augmentation.",
  extraction: "Profit-maximization focus: attention capture, engagement loops, data monetization, aggressive growth tactics. Often prioritizes metrics over user wellbeing.",
  unknown: "Orientation not yet classified. Less than 1% of the dataset remains unclassified after multi-pass LLM enrichment."
};

export const FOUNDER_LABELS = {
  female_only: "Female-Only",
  male_only: "Male-Only",
  mixed: "Mixed Team",
  unknown: "Unknown"
};

export const FOUNDER_DEFINITIONS = {
  female_only: "Founding team consists entirely of women (self-identified, publicly verified or LLM-inferred from public data)",
  male_only: "Founding team consists entirely of men (self-identified, publicly verified or LLM-inferred from public data)",
  mixed: "Founding team includes multiple genders",
  unknown: "Founder data unavailable. Primarily HuggingFace community projects, anonymous open-source contributors, or small-scale apps with no publicly identifiable leadership. Over 80% of the dataset has been resolved via multi-pass web search and LLM enrichment; the remaining ~20% is genuinely undeterminable from public sources."
};

export const GOVERNANCE_LABELS = {
  system_aware: "System-Aware",
  neutral: "Neutral",
  market_first: "Market-First",
  unknown: "Unknown"
};

export const GOVERNANCE_DEFINITIONS = {
  system_aware: "Explicitly mentions safety, ethics, consent, bias mitigation, transparency, or human-in-the-loop governance in product messaging.",
  neutral: "Technical/functional focus without explicit ethical positioning. Neither promotes nor addresses safety concerns.",
  market_first: "Growth-dominant messaging: 'dominate', '10x', 'crush competitors'. Prioritizes scale and revenue in public communications.",
  unknown: "Governance framing not yet classified. Less than 1% of the dataset remains unclassified."
};

export const MONETIZATION_LABELS = {
  free: "Free",
  freemium: "Freemium",
  subscription: "Subscription",
  enterprise: "Enterprise",
  ads: "Ads-Based",
  usage_based: "Usage-Based",
  unknown: "Unknown"
};

export const MONETIZATION_DEFINITIONS = {
  free: "Completely free to use, no paid tiers",
  freemium: "Free tier with paid premium features",
  subscription: "Monthly or annual subscription model",
  enterprise: "B2B sales with custom pricing",
  ads: "Revenue primarily from advertising",
  usage_based: "Pay-per-use or API credits model",
  unknown: "Monetization model not classified. Less than 1% of the dataset remains unclassified."
};

// Shared chart style tokens — use these in ALL chart components
export const CHART = {
  tooltip: {
    contentStyle: {
      backgroundColor: "hsl(240, 6%, 7%)",
      border: "1px solid hsl(240, 5%, 17%)",
      borderRadius: "8px",
      fontSize: 12,
    },
    isAnimationActive: false,
    wrapperStyle: { pointerEvents: "none" },
  },
  axis: { fontSize: 11, fill: "hsl(240, 5%, 65%)" },
  axisStroke: "hsl(240, 5%, 65%)",
  gridStroke: "hsl(240, 5%, 17%)",
  legend: { fontSize: 11 },
  barRadius: [0, 4, 4, 0],      // horizontal bars
  barRadiusV: [4, 4, 0, 0],     // vertical bars
  pieInner: 55,
  pieOuter: 95,
};
